import { ClientItemId } from 'owa-client-ids';
import { PerformanceDatapoint } from 'owa-analytics';
import { action } from 'satcheljs';

export const loadItemAttachment = action(
    'loadItemAttachment',
    (itemAttachmentId: ClientItemId, perfDatapoint: PerformanceDatapoint) => ({
        itemAttachmentId,
        perfDatapoint,
    })
);
